import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { LogIn, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("vk_admin_token", data.access_token);
      localStorage.setItem("vk_admin_user", JSON.stringify(data.user));
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-cream flex">
      <div className="hidden lg:flex lg:w-1/2 bg-[#0F172A] text-cream items-end p-16 relative grain">
        <div>
          <p className="overline text-gold mb-6">Admin · Restricted</p>
          <h1 className="heading-display text-5xl xl:text-6xl font-semibold leading-[1.05] max-w-md">
            The quiet side of the website.
          </h1>
          <p className="mt-6 text-cream/70 max-w-md">
            Sign in to review messages from readers and newsletter signups.
          </p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="w-full max-w-md space-y-6"
        >
          <Link
            to="/"
            data-testid="admin-back-home"
            className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.18em] text-ink/60 hover:text-burgundy"
          >
            <ArrowLeft size={14} /> Back to site
          </Link>
          <div>
            <p className="overline mb-3">Sign in</p>
            <h2 className="heading-display text-4xl font-semibold leading-tight">
              Admin Console
            </h2>
          </div>
          <div>
            <label className="overline block mb-3">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full bg-cream border border-paperline focus:border-burgundy outline-none px-5 py-4"
            />
          </div>
          <div>
            <label className="overline block mb-3">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full bg-cream border border-paperline focus:border-burgundy outline-none px-5 py-4"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="btn-primary w-full disabled:opacity-60"
          >
            {loading ? "Signing in…" : (<><LogIn size={16} /> Sign In</>)}
          </button>
        </form>
      </div>
    </div>
  );
}
